import PropTypes from "prop-types";

export default function FormLayout({ children }) {
  return (
    <div className="forms-layout purple-gradient-inverted">
      <div className="container">
        <div className="row justify-content-center align-items-center ">
          <div className="col-md-6 col-12 pb-5 pt-1 pt-md-5 d-flex flex-column justify-content-center align-items-center ">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

FormLayout.propTypes = {
  children: PropTypes.node,
};
